import { noopT } from "@/plugins/i18n";
import { WalletCategory } from "./enums";

export const WalletCategoryI18nKeys = Object.freeze({
  [WalletCategory.SystemReceive]: noopT(
    "domains.Wallet.categories.SystemReceive"
  ),
  [WalletCategory.SystemCollect]: noopT(
    "domains.Wallet.categories.SystemCollect"
  ),
  [WalletCategory.SystemExpend]: noopT(
    "domains.Wallet.categories.SystemExpend"
  ),
  [WalletCategory.ProviderReceive]: noopT(
    "domains.Wallet.categories.ProviderReceive"
  ),
  [WalletCategory.ProviderCollect]: noopT(
    "domains.Wallet.categories.ProviderCollect"
  ),
  [WalletCategory.ProviderExpend]: noopT(
    "domains.Wallet.categories.ProviderExpend"
  ),
  [WalletCategory.OperatorReceive]: noopT(
    "domains.Wallet.categories.OperatorReceive"
  ),
  [WalletCategory.OperatorCollect]: noopT(
    "domains.Wallet.categories.OperatorCollect"
  ),
  [WalletCategory.OperatorExpend]: noopT(
    "domains.Wallet.categories.OperatorExpend"
  ),
  [WalletCategory.TenantReceive]: noopT(
    "domains.Wallet.categories.TenantReceive"
  ),
  [WalletCategory.TenantCollect]: noopT(
    "domains.Wallet.categories.TenantCollect"
  ),
  [WalletCategory.TenantExpend]: noopT(
    "domains.Wallet.categories.TenantExpend"
  ),
  [WalletCategory.TenantBrokerReceive]: noopT(
    "domains.Wallet.categories.TenantBrokerReceive"
  ),
  [WalletCategory.TenantBrokerCollect]: noopT(
    "domains.Wallet.categories.TenantBrokerCollect"
  ),
  [WalletCategory.TenantBrokerExpend]: noopT(
    "domains.Wallet.categories.TenantBrokerExpend"
  ),
  [WalletCategory.TenantMemberReceive]: noopT(
    "domains.Wallet.categories.TenantMemberReceive"
  ),
  [WalletCategory.TenantMemberCollect]: noopT(
    "domains.Wallet.categories.TenantMemberCollect"
  ),
  [WalletCategory.TenantMemberExpend]: noopT(
    "domains.Wallet.categories.TenantMemberExpend"
  ),
  [WalletCategory.External]: noopT("domains.Wallet.categories.External"),
});
